<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页 > 留言管理
    </div>
    <div class="content-info">
      <div class="content-info-title">留言管理</div>
      <div class="message-list">
        <div class="message-item" v-for="item in list" :key="item.id">
          <h3 class="flex-center between-box">
            <b>{{item.org_name}}  {{item.name}}   {{item.tel}}</b><span>{{item.create_time}}</span>
          </h3>
          <p>{{ item.content }}</p>
        </div>
        <div style="padding: 40px;text-align: center;font-size: 16px;color: #999" v-if="noData">暂无数据</div>
        <div style="padding:30px" v-if="list.length>0">
          <el-pagination
            style="text-align: center"
            layout="prev, pager, next"
            page-size="10"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="Number(page)"
          >
          </el-pagination>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "message",
  data() {
    return {
      page:1,
      total:0,
      list:[],
      noData:false
    }
  },
  created() {
    this.$emit('setIndex', 6)
    this.init(this.page)
  },
  methods: {
// 分页
    handleSizeChange(val) {
      this.page = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page = val
      this.init()
    },
    init() {
      this.$api.apiContent.userMessage({
        token: this.$store.state.user.token,
        page:this.page,
        limit:10
      }).then(res => {
        this.list = res.data
        this.total = res.total
        this.noData = res.total>0?false:true
      }).catch(res=>{
        this.list = res.data
        this.total = res.total
        this.noData = res.total>0?false:true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.content-info {
  display: flex;
  flex-direction: column;
  min-height: auto;
  margin-bottom: 30px;

  .content-info-title {
    display: flex;
    flex-direction: row;
    height: 56px;
    line-height: 56px;
    padding: 0 30px;
    border-bottom: 2px solid #f2f2f2;
    position: relative;
    justify-content: space-between;
    font-size: 18px;

    &:before {
      position: absolute;
      top: 17px;
      left: 15px;
      content: '';
      width: 6px;
      height: 22px;
      background-color: #f9aa0d;
    }
  }

  .message-list{
    padding: 30px;
    min-height: 900px;

    .message-item{
      padding-bottom: 15px;
      border-bottom: 1px solid #f1f1f1;
      h3{
        line-height: 36px;
        span{
          font-weight: normal;
          font-size: 14px;
        }
      }
      p{
        line-height: 28px;
      }
    }
  }
}
</style>
